import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePartnerSummary = () => {
  const query = useQuery({
    queryKey: [QueryKeys.PARTNER_SUMMARY],
    queryFn: accountRepo.getPartnerSummary,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UsePartnerSummary = ReturnType<typeof usePartnerSummary>;
